// extracted by mini-css-extract-plugin
export default {"manage-page":"style_manage-page__MR9m7","box-container":"style_box-container__Cu5aC"};